export class ListFindingExclusionsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "FindingExclusionFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortFindingExclusionsBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListFindingExclusionsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
